import { useQuery } from '@tanstack/react-query'
import { rqKeys } from '@/react-query-keys'
import { apiRequestNew } from '@/helpers/request'
import { getMs } from '@/helpers'
import type { T_DocsResponse } from '@/types/responses'

export const useInstructions = (categoryId?: number) => {
  const { data, isLoading } = useQuery<T_DocsResponse>({
    queryKey: [ rqKeys.instructions, categoryId ],
    queryFn: () =>
      apiRequestNew('GET', `/portal/article?path=information/instructions&name=${categoryId}&fields=name,title,content`),
    enabled: !!categoryId,
    staleTime: getMs('15m'),
    refetchOnWindowFocus: false,
  })

  return { data, isLoading }
}
